import "./theme/styles/App.css";
import "@fontsource/inter";
import { SnackbarProvider } from "notistack";
// routes
import Router from "./routes";
// hooks
import useStore from "./contexts/AuthProvider";
// components
import LoadingScreen from "./components/LoadingScreen";

// ----------------------------------------------------------------------

export default function App() {
  const { isInitialized } = useStore();
  return (
    <>
      <SnackbarProvider maxSnack={3}>
        {isInitialized ? <Router /> : <LoadingScreen />}
      </SnackbarProvider>
    </>
  );
}
